import {
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnInit,
	Output,
	QueryList,
	ViewChildren,
	AfterViewInit,
	OnDestroy
} from '@angular/core';
import { MatExpansionPanel } from '@angular/material';
import { FetchElementAllCategoriesResult } from '../../../services/eleview/eleview-backface';
import { Label } from '../../../services/eleview/types/label';
import { ServiceService } from '../../service/service.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'common-label-drawer-for-select',
	templateUrl: './label-drawer-for-select.component.html',
	styleUrls: ['./label-drawer-for-select.component.scss']
})
export class LabelDrawerForSelectComponent implements AfterViewInit, OnDestroy {
	@Input() selectedLabels: Label[];
	@Output() edit = new EventEmitter<FetchElementAllCategoriesResult>();
	@Output() close = new EventEmitter();
	@HostBinding('class.label-drawer-for-select') hostClass = true;
	@ViewChildren('accordionPanel') accordionPanel: QueryList<MatExpansionPanel>;
	panelActiveIndex = 0;
	panelOpenState: { [key: number]: boolean } = {};
	private subject: Subscription[] = [];
	constructor(public svr: ServiceService) {}
	ngOnDestroy() {
		this.subject.forEach(v => v.unsubscribe());
	}
	ngAfterViewInit() {
		this.subject.push(
			this.svr.paramsChange.subscribe(() => {
				this.panelActiveIndex = 0;
				this.panelOpenState = [];
			})
		);
	}

	removeLabel(index: number) {
		this.selectedLabels.splice(index, 1);
	}
	ok() {
		const old = [...this.svr.data.selectedLabels];
		this.svr.data.selectedLabels.splice(0, this.svr.data.selectedLabels.length, ...this.selectedLabels);
		this.subject.push(
			this.svr.refreshData().subscribe(v => {
				if (v.ok) {
					this.close.emit();
				} else {
					this.svr.data.selectedLabels.splice(0, this.svr.data.selectedLabels.length, ...old);
					alert(v.error);
				}
			})
		);
	}
	panelOpened(index: number) {
		this.panelActiveIndex = index;
		this.panelOpenState[index] = true;
	}
	panelClosed(index: number) {
		this.panelOpenState[index] = false;
	}
}
